import { render, staticRenderFns } from "./editCompanyPartialLeaveComponent.vue?vue&type=template&id=83ef31b0&"
import script from "./editCompanyPartialLeaveComponent.vue?vue&type=script&lang=js&"
export * from "./editCompanyPartialLeaveComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports